import { c as _c } from "react/compiler-runtime";
import { NewsletterSplitTestViewApiInterface } from 'modules/newsletters/single/types/newsletter-view-interface';
import { MailingSplitTestWinnerTypeEnum } from 'modules/newsletters/split-test/enum/mailing-split-test-winner-type-enum';
import { SplitTestSettingsInterface } from 'modules/newsletters/split-test/types/newsletter-split-test-interface';
import { useEffect, useState } from 'react';
const setDefaultSplitTestSettings = (newsletterData: NewsletterSplitTestViewApiInterface) => newsletterData.mailingSplitTest.settings ?? {
  // 8 days
  durationInHours: 192,
  emailRatio: 5,
  winnerType: MailingSplitTestWinnerTypeEnum.ClickRate
};
export const useSplitTestSettings = newsletterData => {
  const $ = _c(7);
  let t0;
  if ($[0] !== newsletterData) {
    t0 = setDefaultSplitTestSettings(newsletterData);
    $[0] = newsletterData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [splitTestSettings, setSplitTestSettings] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== newsletterData) {
    t1 = () => {
      setSplitTestSettings(setDefaultSplitTestSettings(newsletterData));
    };
    t2 = [newsletterData];
    $[2] = newsletterData;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== splitTestSettings) {
    t3 = {
      splitTestSettings,
      setSplitTestSettings
    };
    $[5] = splitTestSettings;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};